import OrderModel                     from '@models/shop/OrderModel';
import ProductPricingClientGroupModel from '@models/shop/ProductPricingClientGroupModel';
import VatModel                       from '@models/shop/VatModel';
import doc                            from '@widesk-core/decorators/doc';
import model                          from '@widesk-core/decorators/model';
import ShopServiceModel               from '@/models/ShopServiceModel';
import TimestampAble                  from '@widesk-core/models/traits/TimestampAble';
import Blamable                       from '@/models/traits/Blamable';
import ProductVariantModel            from '@models/shop/ProductVariantModel';

@model.urnResource('order_item')
@doc.path('/order_items/{?id}')
export default class OrderItemModel extends Blamable(TimestampAble(ShopServiceModel)) {
	private declare _tsFilters: {
		'createdAt[after]': string | Date | Dayjs;
		'createdAt[before]': string | Date | Dayjs;
		'createdAt[strictly_after]': string | Date | Dayjs;
		'createdAt[strictly_before]': string | Date | Dayjs;
		'label': string;
		'order': id;
		'productPricingClientGroup': id;
		'productPricingClientGroup.productPricing': id;
		'productVariant': id;
		'productVariant.product': id;
		'updatedAt[after]': string | Date | Dayjs;
		'updatedAt[before]': string | Date | Dayjs;
		'updatedAt[strictly_after]': string | Date | Dayjs;
		'updatedAt[strictly_before]': string | Date | Dayjs;
	};

	private declare _tsSorts: {
		'': string;
		'createdAt': string;
		'id': string;
		'updatedAt': string;
	};	

	@doc.string declare label: string;
	@doc.model(OrderModel) declare order: OrderModel;
	@doc.model(ProductPricingClientGroupModel) declare productPricingClientGroup: ProductPricingClientGroupModel;
	@doc.model(ProductVariantModel) declare productVariant: ProductVariantModel;
	@doc.number declare quantity: number;
	@doc.string declare rate: string;
	@doc.number declare unitPriceExclVat: number;
	@doc.number declare unitPriceInclVat: number;
	@doc.number declare unitPriceVat: number;
	@doc.model(VatModel) declare vat: VatModel;

	public get amountExclTax() {
		return this.unitPriceExclVat * this.quantity;
	}

	public get amountInclTax() {
		return this.unitPriceInclVat * this.quantity;
	}
}

// TODO DOC - Ajouter la propriété "source"